import { createElement } from 'react';
import * as FloraIcons from '@grupoboticario/flora-react-icons';
import { user } from 'core';
import { ButtonIcon, Link } from 'ui/components';
import { Icon, BadgeNotification } from 'ui/components/primitives';
import { NavBarCollapse } from './NavBarCollapse';
import { useHandleTrackClick, useNavBarList } from '../hooks';
import { getEventLabel, getFallbackToLink } from '../helpers';
import type { NavBarListProps } from './NavBarList.d';

const NavBarList = ({ menu, isOpen, onClick, isMobile }: NavBarListProps) => {
  const { handleTrackClick } = useHandleTrackClick();
  const {
    data: {
      isMultiBrand,
      isBlocked,
      cycle: { currentCycle },
    },
  } = user.hooks.useUser();
  const { isActive, onMouseEnter, onMouseLeave, openAccordion } = useNavBarList({
    menu,
    isOpen,
    isMobile,
  });

  const icon = menu?.iconeName ? Icon[menu?.iconeName as keyof typeof Icon] : '';
  const hasSubMenu = !!menu?.submenu;

  if (isBlocked && menu.hideToBlockedReseller) {
    return null;
  }
  const eventLabel = getEventLabel(menu.text, menu.showBadgeNotification || false);

  return (
    <li
      className={isActive ? 'active' : ''}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid="nav-bar-list"
    >
      {menu?.isLink ? (
        <Link
          to={getFallbackToLink(menu, isMultiBrand, currentCycle)}
          onClick={handleTrackClick}
          data-label={`Menu ${menu?.text}`}
          data-event={eventLabel}
        >
          <ButtonIcon key={`navbar-${menu?.text}`} data-testid="nav-bar-link">
            <BadgeNotification showBadge={menu?.showBadgeNotification || false}>
              <>{createElement(icon, { size: 'm' })}</>
            </BadgeNotification>
            <span>
              {menu?.text}{' '}
              {hasSubMenu && <FloraIcons.ChevronDownIcon size={20} aria-hidden={true} />}
            </span>
          </ButtonIcon>
        </Link>
      ) : (
        <ButtonIcon
          key={`navbar-${menu?.text}`}
          onClick={onClick}
          className={openAccordion ? 'active' : ''}
          data-testid="nav-bar-button"
          data-label={`Menu ${menu?.text}`}
          data-event={eventLabel}
        >
          <BadgeNotification showBadge={menu?.showBadgeNotification || false}>
            <>{createElement(icon, { size: 'm' })}</>
          </BadgeNotification>
          <span>
            {menu?.text} {hasSubMenu && <FloraIcons.ChevronDownIcon size={20} aria-hidden={true} />}
          </span>
        </ButtonIcon>
      )}
      {menu?.submenu && (
        <NavBarCollapse
          data={menu?.submenu || []}
          aria-expanded={openAccordion ? 'true' : 'false'}
          dropdown={openAccordion}
        />
      )}
    </li>
  );
};

export default NavBarList;
